import { AppThunk } from '../../../store/rootReducer';
import * as waveActions from '../actions/wave.actions';
import { selectedIdsSelector } from '../selectors/wave.selectors';

export const unselectAllWaves = (): AppThunk => async (dispatch, getState) => {
  try {
    const selectedIds = selectedIdsSelector(getState());
    if (selectedIds.length > 0) {
      dispatch(waveActions.unselectAll({}));
    }
  } catch (err) {
    console.error(err);
  }
};
